// Call plugin.
import * as actionTypes from '../actionTypes'

// Libraries.
import { handleActions } from 'redux-actions'

const reducers = {}

// Replace any previous information with the new information.
reducers[actionTypes.TURN_CHANGED] = {
  next (state, action) {
    return {
      ...state,
      servers: action.payload.servers || state.servers,
      credentials: {
        ...state.credentials,
        ...action.payload.credentials
      }
    }
  }
}

/*
 * Combine all of top-tier reducers into a single reducer.
 */
const reducer = handleActions(reducers, {})
export default reducer
